import { defineComponent as _defineComponent } from 'vue'
import { useI18n } from '@/composables/i18n';
import WizardStep from '../wizard/WizardStep.vue';
import { AlertKPI } from '@/models/enums/AlertsEnums';
import { isNil, valueOrDefault } from '@/utils/misc';
import { required } from '@/utils/validation';
import useVuelidate from '@vuelidate/core';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'VariableSelectionFormWizardStep',
  props: {
    hidden: { type: Boolean },
    kpi: null,
    value: null,
    title: null
  },
  emits: ["input", "enter"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'input', value: string): void;
  (e: 'enter'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  hidden: boolean;
  kpi: AlertKPI | null;
  value: string | null;
  title?: string;
};





const validations = {
  selectedKpi: {
    required,
  },
};
const selectedKpi = computed({
  get() {
    return props.value;
  },
  set(newValue) {
    emit('input', newValue!);
  },
});
const v$ = useVuelidate(validations, { selectedKpi });

const { t } = useI18n();

const kpiVariableOptions = computed(() => props.kpi!.variableValues);

const validationMessage = computed(
  () => v$.value.selectedKpi.$errors[0]?.$message,
);

return { __sfc: true,props, emit, validations, selectedKpi, v$, t, kpiVariableOptions, validationMessage, WizardStep, isNil, valueOrDefault }
}

})